import { ReactNode } from "react";
import styled from "styled-components";
import Header from "./Header";
import { useAppSelector } from "../hooks/reduxHooks";

interface Props {
  children: ReactNode;
}

const GlobalContainer = styled.div<{ $mode: boolean }>`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: auto;
  margin: auto;
  background: ${({ $mode }) => ($mode ? "#282641" : "white")};
  color: ${({ $mode }) => ($mode ? "white" : "")};
`;

const Title = styled.div`
  padding: 0 15px;
  padding-top: 20px;
  font-family: "KARMATIC ARCADE";
  font-size: 3rem;
  text-align: center;
`;

const SubTitle = styled.div`
  font-size: 1.3rem;
  text-align: center;
`;

export default function Layout({ children }: Props) {
  const mode = useAppSelector((state) => state.mode.mode);
  return (
    <GlobalContainer $mode={mode}>
      <Header />
      <Title>Pokedex</Title>
      <SubTitle> -- All About POKEMON -- </SubTitle>
      {children}
    </GlobalContainer>
  );
}
